
(function() {
  var VARIANT_ID = window.KSM_VARIANT_ID;
  var selectedQty = 1;
  function ksmFmt(v) { return '€' + Number(v).toFixed(2).replace('.', ','); }

  /* Gallery */
  var thumbs = document.querySelectorAll('#ksmGalleryThumbs img');
  var mainImg = document.getElementById('ksmGalleryMain');
  thumbs.forEach(function(t) {
    t.addEventListener('click', function() {
      thumbs.forEach(function(x) { x.classList.remove('active'); });
      t.classList.add('active');
      mainImg.src = t.getAttribute('data-src');
    });
  });

  /* Pricing */
    window.ksmSelectQty = function(qty) {
    selectedQty = qty;
    document.querySelectorAll('.ksm-price-option').forEach(function(o) {
      o.classList.toggle('active', parseInt(o.getAttribute('data-qty')) === qty);
    });
    var sel = document.querySelector('.ksm-price-option[data-qty="' + qty + '"]');
    if (sel) {
      var total = sel.getAttribute('data-total');
      var old = sel.getAttribute('data-old');
      var perKit = sel.getAttribute('data-per-kit') || total;
      var fmt = ksmFmt;
      document.getElementById('ksmBtnPrice').textContent = fmt(total);
      var stPrice = document.getElementById('ksmStickyPrice'); if (stPrice) stPrice.textContent = fmt(total);
      var stOld = document.getElementById('ksmStickyOld'); if (stOld) stOld.textContent = fmt(old);
      var stQty = document.getElementById('ksmStickyQty'); if (stQty) stQty.textContent = qty + ' Kit';
      var stPerKit = document.getElementById('ksmStickyPerKit'); if (stPerKit) stPerKit.textContent = fmt(perKit);
      // Hide redundant info when only 1 kit (per-kit == total)
      var totalLabel = document.getElementById('ksmStickyTotalLabel');
      if (totalLabel) {
        var isSingle = parseInt(qty, 10) === 1;
        totalLabel.style.display = isSingle ? 'none' : '';
        if (stPrice) stPrice.style.display = isSingle ? 'none' : '';
        // Also hide the "·" separator that sits before TOTALE
        var sep = totalLabel.previousElementSibling;
        if (sep && sep.tagName === 'SPAN') sep.style.display = isSingle ? 'none' : '';
      }
    }
  };
  // Sticky qty +/- selector
  window.ksmStickyQtyChange = function(delta) {
    var current = parseInt(document.querySelector('.ksm-price-option.active')?.getAttribute('data-qty') || '1', 10);
    var next = Math.max(1, Math.min(3, current + delta));
    if (next !== current) window.ksmSelectQty(next);
  };

  // Keep the sticky numeric badge in sync with the main qty
  (function(){
    var origSelect = window.ksmSelectQty;
    window.ksmSelectQty = function(qty){
      origSelect.apply(this, arguments);
      var stNum = document.getElementById('ksmStickyQtyNum');
      if (stNum) stNum.textContent = String(qty);
    };
  })();

  // Run once on init so the sticky reflects the default selection (1 kit)
  try { window.ksmSelectQty(1); } catch (e) {}

  /* Reset CTA to default label (so when user navigates back, it isn't stuck on "Aggiunto") */
  function ksmCtaDefaultHtml() {
    var btnPrice = '';
    try {
      var sel = document.querySelector('.ksm-price-option.active');
      if (sel) {
        var total = sel.getAttribute('data-total');
        if (total) btnPrice = ksmFmt(total);
      }
    } catch (e) {}
    return '<span style="white-space:nowrap !important">Aggiungi al carrello</span> <span style="opacity:.5 !important">·</span> <span id="ksmBtnPrice" style="white-space:nowrap !important">' + btnPrice + '</span>';
  }
  function ksmResetCta() {
    var btn = document.getElementById('ksmAddBtn');
    if (!btn) return;
    btn.innerHTML = ksmCtaDefaultHtml();
    btn.disabled = false;
  }
  // Reset whenever page becomes visible again (back/forward navigation, tab switch)
  window.addEventListener('pageshow', ksmResetCta);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') ksmResetCta();
  });

  /* Add to cart — opens theme's sliding cart drawer (no redirect) */
  window.ksmAddToCart = function() {
    var btn = document.getElementById('ksmAddBtn');
    if (btn.disabled) return;
    btn.innerHTML = 'Aggiungo...';
    btn.disabled = true;

    var cartDrawer = document.querySelector('cart-drawer');

    // Build sections list as comma-separated string (Shopify accepts both, but string is widest)
    var sectionsString = null;
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        sectionsString = cartDrawer.getSectionsToRender().map(function(s){ return s.section; }).join(',');
      } catch (e) {}
    }

    var formData = new FormData();
    formData.append('id', String(VARIANT_ID));
    formData.append('quantity', String(selectedQty));
    if (sectionsString) {
      formData.append('sections', sectionsString);
      formData.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(r) {
        // Only treat as REAL error if HTTP response itself failed
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(parsedState) {
        // Cart-add succeeded — never bail out from here on, just be defensive
        if (parsedState && parsedState.status && parsedState.status >= 400) {
          // Shopify returned a soft error (e.g. out of stock) — show it inline
          ksmResetCta();
          alert(parsedState.description || 'Impossibile aggiungere al carrello.');
          return;
        }

        btn.innerHTML = '✓ Aggiunto';

        // Each side-effect below is wrapped — none should ever surface to the user
        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ksm-pdp', productVariantId: VARIANT_ID, cartData: parsedState });
          }
        } catch (e) { console.warn('publish failed', e); }

        try {
          var opened = false;
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState && parsedState.sections) {
            try { cartDrawer.renderContents(parsedState); opened = true; }
            catch (e) { console.warn('renderContents failed', e); }
          }
          if (!opened && cartDrawer) {
            try { if (typeof cartDrawer.reload === 'function') cartDrawer.reload(); } catch (e) {}
            setTimeout(function() {
              try {
                if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
                else document.dispatchEvent(new CustomEvent('cart:open'));
              } catch (e) { console.warn('open failed', e); }
            }, 80);
          } else if (!cartDrawer) {
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
        } catch (e) { console.warn('drawer open chain failed', e); }

        setTimeout(ksmResetCta, 1500);
      })
      .catch(function(err) {
        // Reached only if /cart/add.js never returned a 2xx response
        console.error('ksmAddToCart fetch error', err);
        ksmResetCta();
        alert('Errore di rete. Riprova.');
      });
  };

  /* Sticky */
  var stickyAtc = document.getElementById('ksmStickyAtc');
  var heroPdp = document.querySelector('.ksm-hero-pdp');
  var footerCta = document.querySelector('.ksm-footer-cta');
  function checkSticky() {
    if (!heroPdp || !stickyAtc) return;
    var heroBottom = heroPdp.getBoundingClientRect().bottom;
    var footerTop = footerCta ? footerCta.getBoundingClientRect().top : 99999;
    stickyAtc.classList.toggle('visible', heroBottom < 0 && footerTop > window.innerHeight - 80);
  }
  window.addEventListener('scroll', checkSticky, { passive: true });
  window.addEventListener('resize', checkSticky);
  setTimeout(checkSticky, 100);

  /* Scroll fade-in animations */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.ksm-fade').forEach(function(el) { io.observe(el); });
  } else {
    document.querySelectorAll('.ksm-fade').forEach(function(el) { el.classList.add('in'); });
  }

  /* QUIZ */
  var quizScore = 0, quizStep = 1, quizTotal = 4;
  window.ksmQuizAns = function(btn) {
    quizScore += parseInt(btn.getAttribute('data-score')) || 0;
    var current = document.querySelector('.ksm-quiz-step[data-step="' + quizStep + '"]');
    if (current) current.classList.remove('active');
    quizStep++;
    if (quizStep <= quizTotal) {
      var next = document.querySelector('.ksm-quiz-step[data-step="' + quizStep + '"]');
      if (next) next.classList.add('active');
      var fill = document.getElementById('ksmQuizFill');
      if (fill) fill.style.width = (quizStep * 25) + '%';
    } else {
      var resultStep = document.querySelector('.ksm-quiz-step[data-step="result"]');
      if (resultStep) resultStep.classList.add('active');
      var fill = document.getElementById('ksmQuizFill');
      if (fill) fill.style.width = '100%';
      ksmQuizShowResult(quizScore);
    }
  };
  function ksmQuizShowResult(score) {
    var emoji = document.getElementById('ksmQuizEmoji');
    var title = document.getElementById('ksmQuizResultTitle');
    var text = document.getElementById('ksmQuizResultText');
    if (score >= 6) {
      emoji.innerHTML = '&#127769;';
      title.textContent = 'Sì, il Kit Sonno è per te.';
      text.innerHTML = 'Addormentamento lento, testa accesa, risvegli: <strong>è il profilo esatto per cui è nato il kit.</strong> Due fronti, un rituale serale. Parti da un ciclo completo di 2 mesi.';
    } else if (score >= 3) {
      emoji.innerHTML = '&#10024;';
      title.textContent = 'Vale la pena provarlo.';
      text.innerHTML = 'Alcune notti sono più difficili di altre. Il kit ti dà <strong>un rituale preciso per le sere che non rallentano</strong>. Valutalo sull&#39;intero ciclo di 60 giorni.';
    } else {
      emoji.innerHTML = '&#128564;';
      title.textContent = 'Dormi già bene.';
      text.innerHTML = 'I segnali sono pochi. Se viaggi spesso o hai periodi intensi, tieni il kit per quelle settimane: la melatonina contribuisce anche ad alleviare gli effetti soggettivi del jet lag.*';
    }
  }

  /* CAROUSELS */
  window.ksmCarouselScroll = function(trackId, dir) {
    var track = document.getElementById(trackId);
    if (!track) return;
    var card = track.querySelector('.ksm-mech-card, .ksm-efsa-card, .ksm-bot-card');
    var step = card ? card.offsetWidth + parseInt(getComputedStyle(track).gap || 18) : 320;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  function setupCarousel(trackId, dotsId) {
    var track = document.getElementById(trackId);
    var dotsEl = document.getElementById(dotsId);
    if (!track || !dotsEl) return;
    var cards = track.children.length;
    dotsEl.innerHTML = '';
    for (var i = 0; i < cards; i++) {
      (function(idx) {
        var d = document.createElement('button');
        d.className = 'ksm-carousel-dot' + (idx === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Card ' + (idx + 1));
        d.onclick = function() {
          var card = track.children[idx];
          if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        };
        dotsEl.appendChild(d);
      })(i);
    }
    function updateDots() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var bestIdx = 0, bestDist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var r = track.children[i].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var dist = Math.abs(c - center);
        if (dist < bestDist) { bestDist = dist; bestIdx = i; }
      }
      Array.from(dotsEl.children).forEach(function(d, i) {
        d.classList.toggle('active', i === bestIdx);
      });
    }
    track.addEventListener('scroll', updateDots, { passive: true });
    setTimeout(updateDots, 50);

    /* drag to scroll on desktop */
    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function(e) {
      isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function() { isDown = false; });
    track.addEventListener('mouseup', function() { isDown = false; });
    track.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX);
    });
  }
  setupCarousel('ksmMechTrack', 'ksmMechDots');
  setupCarousel('ksmEfsaTrack', 'ksmEfsaDots');

  /* CORTISOL STAGGER ANIMATION */
  if ('IntersectionObserver' in window) {
    var ioCort = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          ioCort.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.ksm-cortisol-step').forEach(function(el) { ioCort.observe(el); });
  }

  /* QUALITY STAGGER */
  if ('IntersectionObserver' in window) {
    var ioQ = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          ioQ.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('.ksm-quality-card').forEach(function(el) { ioQ.observe(el); });
  }

    /* REVIEWS */
  var FALLBACK = [{"s": 4, "t": "Associo Relax a mag5+ e riesco a dormire molto meglio. Ero disperata prima perché mi facevo un sacco di notti insonni. Non do 5 stelle perché voglio vedere nel lungo periodo ma per il momento sono soddisfatta.", "n": "Katia U.", "i": "KU", "p": "Relax", "d": "14 ott 2025", "img": "https://images.loox.io/uploads/2025/10/14/rdl4H_lj0_mid.jpg", "tags": ["sonno", "kit", "relax", "foto"]}, {"s": 5, "t": "mi trovo molto bene...il sonno ora è un buon sonno profondo!", "n": "Serena D.", "i": "SD", "p": "MAG-5+", "d": "30 set 2026", "img": "https://images.loox.io/uploads/2026/9/30/KXssZgFlh_mid.jpg", "tags": ["sonno", "magnesio", "foto"]}, {"s": 5, "t": "In pochi giorni sono riuscita a dormire tutta la notte", "n": "Arianna P.", "i": "AP", "p": "Relax", "d": "16 mag 2026", "img": null, "tags": ["sonno", "relax"]}, {"s": 5, "t": "Da quando la sera prendo magnesio mi addormento più facilmente e sento i muscoli rilassati", "n": "Francesca R.", "i": "FR", "p": "MAG-5+", "d": "24 set 2026", "img": null, "tags": ["addormentamento", "magnesio"]}, {"s": 5, "t": "I primi giorni non ho notato grandi differenze. Adesso devo dire che mi sta aiutando molto a dormire meglio e di più. Mi svegliavo spesso la notte prima. Adesso mi capita meno e, se succede, riesco a riaddormentarmi", "n": "Daniela F.", "i": "DF", "p": "Relax", "d": "12 ago 2025", "img": null, "tags": ["sonno", "risvegli", "relax"]}, {"s": 5, "t": "Lo sto usando da qualche settimana, qualità del sonno migliorata e recupero muscolare per attività sportiva... TOP 🔝🔝🔝", "n": "Stefano M.", "i": "SM", "p": "MAG-5+", "d": "23 set 2026", "img": "https://images.loox.io/uploads/2026/9/23/gNEXzHmOh_mid.jpg", "tags": ["sonno", "magnesio", "foto"]}, {"s": 5, "t": "Mi ha risolto i miei problemi. Facevo un po' fatica ad addormentarmi e con questo ho risolto", "n": "Giovanni", "i": "G", "p": "Relax", "d": "15 dic 2023", "img": null, "tags": ["addormentamento", "relax"]}, {"s": 5, "t": "Mantiene il mio sonno profondo e rigenerante senza causare sonnolenza al mattino.", "n": "Francisca", "i": "F", "p": "Relax", "d": "22 dic 2023", "img": null, "tags": ["sonno", "relax"]}, {"s": 5, "t": "Sto prendendo Gofor magnesio da aprile, sono molto contenta mi fa riposare mi ricarica e ' super!!!!!!", "n": "Marzia C.", "i": "MC", "p": "MAG-5+", "d": "21 set 2026", "img": null, "tags": ["magnesio"]}, {"s": 4, "t": "Nessun problema ad addormentarmi", "n": "Marcello R.", "i": "MR", "p": "Relax", "d": "8 ott 2026", "img": "https://images.loox.io/uploads/2026/10/8/Hd0acAZlTu_mid.jpg", "tags": ["addormentamento", "relax", "foto"]}, {"s": 5, "t": "Perfetto per rilassarsi i muscoli", "n": "Massimiliano C.", "i": "MC", "p": "MAG-5+", "d": "1 ott 2026", "img": "https://images.loox.io/uploads/2026/10/1/uHyXJtO14_mid.jpg", "tags": ["magnesio", "foto"]}, {"s": 5, "t": "Mi ha permesso di migliorare la qualità del mio sonno e di dormire in modo più profondo.", "n": "Hamish", "i": "H", "p": "Relax", "d": "15 nov 2023", "img": null, "tags": ["sonno", "relax"]}, {"s": 5, "t": "Ho iniziato il trattamento da 15 giorni e ho già avuto grandi cambiamenti. \nA dire il vero già dal primo giorno,ovvero dal 26/03/2026, ho sentito un clic interiore non indifferente, più focus mentale, più rilassamento, un sonno sereno e riposante, la mattina al risveglio energie fisica e mentale .\nSudorazione ritornata nella norma .\nE soprattutto per me che sono intollerante al lattosio e colon irritabile, non ho avuto tutti quei sintomi assurdi di colite,cosa che tutti gli altri tipi di magnesio usati fin ora mi hanno dato . Il sapore poi di limone lo trovo molto delicato e gradevole. Grazie infinite . Non lo lascerò più.", "n": "Maria S.", "i": "MS", "p": "Relax", "d": "13 apr 2026", "img": null, "tags": ["relax"]}, {"s": 5, "t": "mag 5 ottimo mi trovo bene a prenderlo, ormai sono 7 barattoli che acquisto", "n": "Claudio P.", "i": "CP", "p": "MAG-5+", "d": "9 ott 2026", "img": null, "tags": ["magnesio"]}, {"s": 5, "t": "È diventato un'importante parte della mia routine per dormire.", "n": "Damiano", "i": "D", "p": "Relax", "d": "20 nov 2023", "img": null, "tags": ["sonno", "relax"]}, {"s": 4, "t": "Ottimo magnesio bisglicinato,unica pecca che non si scioglie facilmente nell'acqua,anche se è tiepida", "n": "Marco M.", "i": "MM", "p": "MAG-5+", "d": "2 ott 2026", "img": "https://images.loox.io/uploads/2026/10/2/-A-7l-EbQ_mid.jpg", "tags": ["magnesio", "foto"]}, {"s": 4, "t": "finalmente ho ritrovato un sonno naturale e ristoratore.", "n": "Clodoveo", "i": "C", "p": "Relax", "d": "1 feb 2024", "img": null, "tags": ["sonno", "relax"]}, {"s": 5, "t": "Io lo uso per il jetlag e un po' aiuta. Ci metto qualche giorno meno ad adattarmi", "n": "Elena", "i": "E", "p": "Relax", "d": "30 dic 2023", "img": null, "tags": ["addormentamento", "relax"]}, {"s": 5, "t": "Un ottimo prodotto, dal sapore gradevole, che rispetta le aspettative.", "n": "Massimo P.", "i": "MP", "p": "MAG-5+", "d": "4 ott 2026", "img": "https://images.loox.io/uploads/2026/10/4/420eSQmZJ_mid.jpg", "tags": ["magnesio", "foto"]}, {"s": 5, "t": "Ottime compresse!", "n": "Pamela M.", "i": "PM", "p": "Relax", "d": "5 set 2026", "img": "https://images.loox.io/uploads/2026/9/5/cvqa-rQhY_ul_lBk2T-_orig_mid.jpg", "tags": ["relax", "foto"]}, {"s": 4, "t": "Gli effetti gli ho sentito subito. Mi sono trovata bene", "n": "Vanina R.", "i": "VR", "p": "Relax", "d": "9 ott 2025", "img": null, "tags": ["relax"]}, {"s": 5, "t": "Ottimo prodotto ben tollerato", "n": "Paolo S.", "i": "PS", "p": "MAG-5+", "d": "2 ott 2026", "img": null, "tags": ["magnesio"]}];
  window.KSM_REVIEWS = FALLBACK;
  var PER_PAGE = 6, currentPage = 1, filtered = [];
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function starsHtml(n) { var s = ''; for (var i = 0; i < 5; i++) s += '<b' + (i < n ? '' : ' class="off"') + '>★</b>'; return s; }
  function renderCard(rev) {
    var img = rev.img ? '<img class="ksn-rev-img" src="' + rev.img + '" alt="Foto di ' + esc(rev.n) + '" loading="lazy">' : '';
    var authorHtml = '<div class="ksm-review-author"><div class="ksm-review-avatar">' + esc(rev.i || '?') + '</div><div><div class="ksm-review-name">' + esc(rev.n) + '</div><div class="ksm-review-verified">✓ Acquisto verificato</div></div></div>';
    return '<div class="ksm-review-card"><div class="ksn-rev-top"><div class="ksm-review-stars">' + starsHtml(rev.s) + '</div><span class="ksn-rev-date">' + esc(rev.d || '') + '</span></div>' + img + '<div class="ksm-review-text">' + esc(rev.t) + '</div><span class="ksn-rev-prod">Recensione su ' + esc(rev.p) + '</span>' + authorHtml + '</div>';
  }
  function applyFilter(filter) {
    currentPage = 1;
    var reviews = window.KSM_REVIEWS || [];
    filtered = filter === 'all' ? reviews.slice() : reviews.filter(function(r) { return r.tags && r.tags.indexOf(filter) !== -1; });
    renderPage();
  }
  function renderPage() {
    var grid = document.getElementById('ksmRevGrid');
    var moreBtn = document.getElementById('ksmRevMore');
    var empty = document.getElementById('ksmRevEmpty');
    if (!grid) return;
    var end = currentPage * PER_PAGE;
    var html = '';
    filtered.slice(0, end).forEach(function(rev) { html += renderCard(rev); });
    grid.innerHTML = html;
    if (filtered.length === 0) { empty.style.display = 'block'; moreBtn.style.display = 'none'; }
    else { empty.style.display = 'none'; moreBtn.style.display = end < filtered.length ? 'block' : 'none'; }
  }
  window.ksmRevLoadMore = function() { currentPage++; renderPage(); };
  document.querySelectorAll('.ksm-rev-filter').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.ksm-rev-filter').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      applyFilter(btn.getAttribute('data-filter'));
    });
  });
  applyFilter('all');
})();

/* Value block + guarantee + perks animation observer */
(function() {
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('ksm-vis');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.18 });
  document.querySelectorAll('.ksm-value-block, .ksm-guarantee, .ksm-perks-row').forEach(function(el) { io.observe(el); });
})();
